import { FunctionComponent } from "react";

import {
  container,
  button,
  icon,
} from "@ui/components/article/ShareButtons/ShareButtons.css";
import ThreadsIcon from "@ui/components/icon/social/ThreadsIcon";
import { ArticleLayout } from "@ui/components/ledes/ledes.types";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

interface Props {
  url: string;
  title: string;
  layout: ArticleLayout | "stream" | "video";
}

const ShareButtonsThreads: FunctionComponent<Props> = ({
  url,
  title,
  layout,
}) => {
  const analytics = useAnalytics();
  const handleClick = () => {
    analytics?.emit({
      event: "social_share",
      social_share: { platform: "threads" },
    });

    const threadsUrl = `https://threads.net/intent/post?text=${title}&url=${url}&via=Verge`;

    return window.open(
      threadsUrl,
      "share_threads",
      "width=658, height=354, scrollbars=no",
    );
  };

  return (
    <div className={container}>
      <button
        aria-label="Share on Threads"
        onClick={handleClick}
        className={button[layout]}
      >
        <ThreadsIcon className={icon[layout]} />
      </button>
    </div>
  );
};

export default ShareButtonsThreads;
